<template>
  <div id="footer" class="w100">
    <hr />
    <div class="p-col-12 p-d-flex">
      <div class="p-col-3 has-text-left" style="width: auto">
        <img
          :src="getLogoUrl"
          class="public-page-logo cursorpointer"
          alt="$t('diamond-scheduler-logo')"
          @click="goRouter(`/public/${domain}`)"
        />
      </div>

      <div class="p-col-1" />

      <div class="p-col-2 p-d-flex p-dir-col has-text-left links-gap-vertical normalWeight">
        <span @click="goRouter(`/public/${domain}`)">HOME</span>
        <div class="dropdown-link-area" v-if="showTeamsPage">
          <span class="dropdown-link">TEAMS</span>
          <div class="dropdown-link-content overflow-200">
            <div v-for="t in teams" :key="t.id" @click="goRouter(`/public/${domain}/team/${t.id}`)">
              {{ t.name }}
            </div>
          </div>
        </div>
        <span @click="goRouter(`/public/${domain}/standings`)" v-if="showStandingsPage">STANDINGS</span>
        <span @click="goRouter(`/public/${domain}/schedules`)" v-if="showSchedulesPage">SCHEDULES</span>
        <span @click="goRouter(`/public/${domain}/scores`)" v-if="showScoresPage">SCORES</span>
      </div>
    </div>
    <hr />
    <div class="p-flex-column p-justify-center">
      <div class="opacity-50 normalWeight">
        <div>
          Schedules and website powered by
          <a href="https://cactusware.com">Diamond Scheduler, Inc</a>.
        </div>
        <div class="links-gap my-4">
          <a href="https://cactusware.com/terms_of_service">{{ $t("terms-of-service") }}</a>
          <a href="https://cactusware.com/privacy_policy">{{ $t("privacy-policy") }}</a>
          <a href="https://cactusware.com/contact">{{ $t("contact") }}</a>
        </div>
        <div>
          Diamond Scheduler ® 2023
        </div>
        <img
          src="https://diamond-public.s3.us-west-2.amazonaws.com/assets/diamond-logo-white.png"
          width="100"
          alt="DS Logo"
          style="mix-blend-mode: multiply; margin-top: 5px;"
        />
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  props: [
    "seasonId",
    "showTeamsPage",
    "showStandingsPage",
    "showSchedulesPage",
    "showScoresPage",
    "showRostersPage",
    "logoUrl",
    "domain",
  ],
  data() {
    return {
      teams: [],
    };
  },
  methods: {
    fetchData(seasonId) {
      api.getSeasonTeams(seasonId).then(response => {
        this.teams = response.data;
      });
    },
  },
  computed: {
    getLogoUrl() {
      const defaultLogoUrl = "https://diamond-public.s3.us-west-2.amazonaws.com/assets/diamond-logo-white.png";
      if (this.logoUrl) {
        return this.logoUrl;
      } else {
        return defaultLogoUrl;
      }
    },
  },
  mounted() {
    if (this.seasonId) this.fetchData(this.seasonId);
  },
};
</script>
